import LegalLayout from "@/components/LegalLayout";
import SEO from "@/components/SEO";

export default function Cookies() {
  return (
    <>
      <SEO
        title="Cookie Policy"
        description="How United Techlab uses cookies and similar technologies on this website."
        path="/cookies"
      />
      <LegalLayout
        eyebrow="> /legal/cookies"
        title="Cookie Policy"
        lastUpdated="December 2025"
      >
        <p>
          This policy explains how United Techlab uses cookies and similar
          technologies on our website.
        </p>

        <h2>1. What are cookies?</h2>
        <p>
          Cookies are small text files stored on your device when you visit a
          website. They help the site remember your preferences and collect
          information about usage.
        </p>

        <h2>2. Types of cookies we use</h2>
        <ul>
          <li>
            <strong className="text-white">Strictly necessary</strong>: required for the website to function (e.g., security, basic navigation).
          </li>
          <li>
            <strong className="text-white">Analytics</strong>: help us understand how visitors use the site so we can improve it.
          </li>
          <li>
            <strong className="text-white">Functional</strong>: remember your preferences (e.g., theme, language).
          </li>
        </ul>

        <h2>3. Third-party cookies</h2>
        <p>
          We may use reputable third-party services (such as analytics or
          content delivery networks) that set their own cookies. Their usage is
          governed by their respective privacy policies.
        </p>

        <h2>4. Managing cookies</h2>
        <p>
          Most browsers allow you to control cookies via their settings. You
          can block or delete cookies at any time. Note that disabling some
          cookies may affect how the website functions.
        </p>

        <h2>5. Updates</h2>
        <p>
          We may update this cookie policy periodically. Please revisit this
          page to stay informed of any changes.
        </p>

        <h2>6. Contact</h2>
        <p>
          Questions? Email{" "}
          <a href="mailto:contact@unitedtechlab.com">contact@unitedtechlab.com</a>.
        </p>
      </LegalLayout>
    </>
  );
}
